import TripsTabSupplier from './Tabs/TripTabsSupplier';
import PassBookTabSupplier from './Tabs/PassBookTabSupplier';

const baseUrl = "/suppliers/single-supplier";

export default {
    tabs: [
        {
            path: baseUrl + '/trips/',
            name: 'Trips',
            type: 'tab',
            component: TripsTabSupplier,
            state: {
                id: 1,
                pageTitle: 'Trips'
            }
        },
        {
            path: baseUrl + '/passbook/',
            name: 'Passbook',
            type: 'tab',
            component: PassBookTabSupplier,
            state: {
                id: 1,
                pageTitle: 'Passbook'
            }
        }
    ]
}